import React from 'react';
import { styled } from "@mui/material/styles";
import MuiToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import TR from '../../Trans';

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    background: "var(--text-color) !important",
    color: "var(--bg-color) !important"
  }
});

function PositionButtons(props) {

  const renderSecond = () => {
    if (props.isAdding || props.isSmartQ) {
      if (props.performances.length > 1) {
        return <ToggleButton className="muvika-pos-toggle-button" value={1}>
          {TR.cm_song_pos_2}
        </ToggleButton>;
      }
    } else {
      if (props.performances.length > 2) {
        return <ToggleButton className="muvika-pos-toggle-button" value={1}>
          {TR.cm_song_pos_2}
        </ToggleButton>;
      }
    }
  };

  const renderThird = () => {
    if (props.isAdding || props.isSmartQ) {
      if (props.performances.length > 2) {
        return <ToggleButton className="muvika-pos-toggle-button" value={2}>
          {TR.cm_song_pos_3}
        </ToggleButton>;
      }
    } else {
      if (props.performances.length > 3) {
        return <ToggleButton className="muvika-pos-toggle-button" value={2}>
          {TR.cm_song_pos_3}
        </ToggleButton>;
      }
    }
  };

  const renderPos = () => {
    if (props.currentPosition) {
      if (props.isAdding) {
        if (props.isSmartQ) {
          if (props.currentPosition > 2 && props.currentPosition < props.performances.length +1 && props.performances.length > 4) {
            return <span>&nbsp;({props.currentPosition + 1})</span>;
          }
        } else {
          if (props.currentPosition > 2 && props.currentPosition < props.performances.length && props.performances.length > 4) {
            return <span>&nbsp;({props.currentPosition + 1})</span>;
          }
        }
      } else {
        if (props.isSmartQ) {
          if (props.currentPosition > 2 && props.currentPosition < props.performances.length && props.performances.length > 3) {
            return <span>&nbsp;({props.currentPosition + 1})</span>;
          }
        } else {
          if (props.currentPosition > 2 && props.currentPosition < props.performances.length - 1 && props.performances.length > 4) {
            return <span>&nbsp;({props.currentPosition + 1})</span>;
          }
        }
      }
    }
  };

  const renderLast = () => {
    if (props.isAdding) {
      if (props.performances.length > 0) {
        if (props.isPlayQueue && props.isSmartQ) {
          return <ToggleButton className="muvika-pos-toggle-button" value={-2}>
            SmartQ
          </ToggleButton>;
        } else {
          if (!props.isAdding) {
            return <ToggleButton className="muvika-pos-toggle-button" value={props.performances.length - 1}>
              {TR.cm_song_pos_last}
            </ToggleButton>;
          } else {
            return <ToggleButton className="muvika-pos-toggle-button" value={props.performances.length}>
              {TR.cm_song_pos_last}
            </ToggleButton>;
          }
        }
      }
    } else {
      if (props.performances.length > 1) {
        if (props.isPlayQueue && props.isSmartQ) {
          return <ToggleButton className="muvika-pos-toggle-button" value={-2}>
            SmartQ
          </ToggleButton>;
        } else {
          if (!props.isAdding) {
            return <ToggleButton className="muvika-pos-toggle-button" value={props.performances.length - 1}>
              {TR.cm_song_pos_last}
            </ToggleButton>;
          } else {
            return <ToggleButton className="muvika-pos-toggle-button" value={props.performances.length}>
              {TR.cm_song_pos_last}
            </ToggleButton>;
          }
        }
      }
    }
  };

  const renderFirst = () => {
    if (props.isPlayQueue) {
      return <ToggleButton className="muvika-pos-toggle-button" value={0}>
        {TR.cm_song_pos_now}
      </ToggleButton>;
    } else {
      return <ToggleButton className="muvika-pos-toggle-button" value={0}>
        {TR.cm_song_pos_1}
      </ToggleButton>;
    }
  };

  const renderOther = () => {
    if (props.isAdding) {
      if (props.performances.length > 4) {
        return <ToggleButton className="muvika-pos-toggle-button" value={-1}>
          {TR.cm_other} {renderPos()}
        </ToggleButton>;
      }
    } else {
      if (props.performances.length > 3) {
        return <ToggleButton className="muvika-pos-toggle-button" value={-1}>
          {TR.cm_other} {renderPos()}
        </ToggleButton>;
      }
    }
  };

  return (
    <ToggleButtonGroup
      defaultValue={props.value}
      value={props.value}
      exclusive
      onClick={props.onPosChange}
      aria-label="text alignment"
      className="muvika-pos-buttons-group"
    >
      {renderFirst()}
      {renderSecond()}
      {renderThird()}
      {renderLast()}
      {renderOther()}
    </ToggleButtonGroup>
  );
}

export default PositionButtons;